import orderRouteEditPassengerValidationService from "../../order-route-edit-passenger-validation.service";

const orderRouteEditInternalPassengerEditFormValidationService = {
  validateExternalId:
    orderRouteEditPassengerValidationService.validateExternalId,
};

export default orderRouteEditInternalPassengerEditFormValidationService;
